import React, { useState, useEffect } from "react";
import UISectionHeading from "../../Common/UISectionHeading/UISectionHeading";
import UiButton from "../../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../Common/UITextInput/TextInput";
import { Form, Input, message, Checkbox } from "antd";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import { connect } from "react-redux";
import { saveAccountNoDetails } from "../../../redux/FirmBankDetails/action";
import useForm from "../../../common/hooks/useForm";
import {
  firmDetailMaster,
  getFirmAccountNumberDetail,
} from "../../../redux/firmDetails/addFirmdetailsAction";
import VerificationIc from "../../../images/Verified-Partner.png";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import AsyncSelect from "react-select/async";
import {
  searchBankDetails,
  searchBranchDetails,
} from "../../../redux/bankDetailsDropdown/BankDetailsDropdownAction";
import { clearLogoutData } from "../../../redux/logout/action";
import { useLocation } from "react-router-dom";
import PartnerPortalStatusBar from "../../PartnerPortalStatusBar/PartnerPortalStatusBar";
import useSession from "../../CustomLogout/useSession";

const ModifyBankDetails = (props) => {
  const handleSessionExpired = useSession();

  const location = useLocation();
  const partnerFirmId = location?.state?.partnerFirmId;

  const { setHandleGetYourFirmBankDetails, saveAllIndication } = props;
  const { state, onChangeTextHandler, setState } = useForm();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [showText, setShowText] = useState(false);
  const [partnerFirmMSMEFlagCheck, setPartnerFirmMSMEFlagCheck] =
    useState(false);
  const [bankInputValue, setBankInputValue] = React.useState("");
  const [branchInputValue, setBranchInputValue] = React.useState("");
  const [bankData, setBankData] = React.useState([]);
  const [selectedBankDetails, setSelectedBankDetails] = React.useState("");
  const [change, setChange] = React.useState(false);
  const [selectedBranchDetails, setSelectedBranchDetails] = React.useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const { access_token } = props;
  const [saveLoading, setSaveLoading] = useState(false);
  const Id = sessionStorage.getItem("cetFirmId");

  useEffect(() => {
    props
      .getData(props.state.accessToken.access_token, partnerFirmId)
      .then((res) => {
        if (res?.status === 200) {
          const data = res?.data?.dto;

          setSelectedBankDetails(data?.bankNameDetails?.id);
          setSelectedBranchDetails(
            data?.bankBranchNameDetails
              ? {
                  label: data?.bankBranchNameDetails?.name,
                  value: data?.bankBranchNameDetails?.id,
                }
              : ""
          );
          setBankData(
            data?.bankNameDetails
              ? {
                  label: data?.bankNameDetails?.name,
                  value: data?.bankNameDetails?.id,
                }
              : ""
          );
          form.setFieldValue(
            "bankName",
            data?.bankNameDetails
              ? {
                  label: data?.bankNameDetails?.name,
                  value: data?.bankNameDetails?.id,
                }
              : ""
          );
          form.setFieldValue(
            "bankBranchName",
            data?.bankBranchName ? data?.bankBranchName : ""
          );
          form.setFieldValue(
            "bankAccountType",
            data?.bankAccountType
              ? {
                  label: data?.bankAccountType?.name,
                  value: data?.bankAccountType?.id,
                }
              : ""
          );
          form.setFieldsValue({
            accountHolderName: data?.accountHolderName,
            bankAccountNumber: data?.bankAccountNumber,
            confirmaccuntNumber: data?.bankAccountNumber,
            bankMICRCode: data?.bankMICRCode,
            bankIFSCCode: data?.bankIFSCCode,
            bankAddress: data?.bankAddress,
          });
          setPartnerFirmMSMEFlagCheck(data?.bankVerificationConsentFlag);
          setChange(data?.bankDetailsVerifiedFlag);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, [Id]);

  useEffect(() => {
    props.getfirmMaster(props.state.accessToken.access_token);
  }, []);

  const imgIconShow =
    props.data?.firmAccountNumber?.bankVerificationConsentFlag || false;

  const accountTypeListGet = props.data?.firmAccountNumber?.bankAccountType
    ? {
        label: props.data?.firmAccountNumber?.bankAccountType?.name,
        value: props.data?.firmAccountNumber?.bankAccountType?.id,
      }
    : "";

  const accountTypeListData =
    props?.data?.accountTypeList?.length > 0
      ? props?.data?.accountTypeList?.map((el) => {
          return {
            label: el.value,
            value: el.serialId,
          };
        })
      : [];

  const handleChangeSelect = (val) => {
    setState({
      ...state,
      bankAccountType: {
        id: val.value,
        name: val.label,
      },
    });
  };

  const loadBanks = (bankInputValue, callback) => {
    let bankArray = [];
    if (bankInputValue.length > 2) {
      let params = {
        bankName: bankInputValue,
      };
      props
        .searchBankDetails({
          access_token,
          params,
        })
        .then((res) => {
          // message.loading("Please Wait...", 5);

          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element?.bankName,
                  value: element?.bankCode,
                };
                bankArray.push(values);
              });
            callback(bankArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadBranch = (branchValue, callback) => {
    let branchArray = [];

    if (branchValue.length > 0) {
      let params = {
        bankCode: selectedBankDetails,
        bankBranchDesc: branchValue,
      };
      props
        .searchBranchDetails({
          access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element?.branchDesc,
                  value: element?.bankBranchId,
                  ...element,
                };
                branchArray.push(values);
              });
            callback(branchArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const bankDropChange = (bank) => {
    setSelectedBankDetails(bank.value);
    setSelectedBranchDetails("");
    form.setFieldValue("bankBranchName", "");
    setBankData(bank);
  };

  const branchDropChange = (branch) => {
    setSelectedBranchDetails(branch);

    form.setFieldValue("bankIFSCCode", branch?.ifsc);
  };

  useEffect(() => {
    if (saveAllIndication) {
      form.submit();
    }
  }, [saveAllIndication]);

  const handleChange = (data) => {
    setBtnDisable(true);
    setSaveLoading(true);
    const accountNumberData = {
      bankAccountNumber: data?.bankAccountNumber,
      accountHolderName: data.accountHolderName?.trim(),
      bankAccountType: {
        id: data.bankAccountType?.value ?? data.bankAccountType?.id,
        name: data.bankAccountType?.label ?? data.bankAccountType?.name,
      },
      bankCode: selectedBankDetails,
      bankBranchName: data.bankBranchName?.trim(),
      bankNameDetails: {
        id: bankData?.value,
        name: bankData?.label,
      },
      bankMICRCode: data.bankMICRCode?.trim(),
      bankIFSCCode: data.bankIFSCCode,
      bankAddress: data.bankAddress?.trim(),
      bankVerificationConsentFlag: partnerFirmMSMEFlagCheck,
    };

    if (saveAllIndication) {
      setHandleGetYourFirmBankDetails(accountNumberData);
      setSaveLoading(false);
    } else {
      props
        .saveAccountNoDetails({
          values: accountNumberData,
          access_token: props.access_token,
          partnerFirmId: partnerFirmId,
        })
        .then((res) => {
          setSaveLoading(false);
          setBtnDisable(false);
          if (res && res.status === 200) {
            message.success("Bank Account Verified Successfully");
            setShowText(true);

            setChange(true);
            // props.getData(
            //   props.state.accessToken.access_token,
            //   props.firmId
            // );
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            setBtnDisable(false);
            setSaveLoading(false);
            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          setBtnDisable(false);
          setSaveLoading(false);
          if (err.response) {
            return err.response;
          }
        });
    }
  };

  const handleEdit = () => {
    form.resetFields();
    setPartnerFirmMSMEFlagCheck(false);
    setChange(false);
    imgIconShow = false;
  };

  const preventCopyPaste = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Row>
        <Col md={6}></Col>
        <Col md={5}>
          <div className="model-bank-sec">
            <PartnerPortalStatusBar />
          </div>
        </Col>
      </Row>

      <div className="modifyBankDetails">
        <Form
          autoComplete="off"
          name="bankDetails"
          form={form}
          onFinish={handleChange}
          initialValues={{
            accountTypeListGet: accountTypeListGet,
            bankIFSCCode: selectedBankDetails?.ifsc,
          }}
        >
          <div className="inner-content">
            <Row>
              <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
                <Col md={6} className="leftsidecontent">
                  <div className="subheading">
                    <UISectionHeading secHeading="Modify Bank Details" />
                  </div>
                </Col>
                <Col md={12} className="right-field-section">
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-field-right"
                    >
                      <Col md={7} className="Nature-sec mob-sec-ac">
                        <FormItem
                          name="accountHolderName"
                          label="Account Holder Name"
                          colon={false}
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Account Holder Name",
                            },
                          ]}
                        >
                          <TextInput
                            maxLength={50}
                            name="accountHolderName"
                            onInput={(e) => {
                              if (e.target.value.trim() == "") {
                                e.target.value = e.target.value.trim();
                              }

                              if (e.target.value.trim() !== "") {
                                e.target.value = new RegExp("^[a-zA-Z]+$").test(
                                  e.target.value
                                )
                                  ? e.target.value?.trimStart()
                                  : e.target.value
                                      ?.trimStart()
                                      ?.substring(0, e.target.value.length - 1);
                              }
                            }}
                            value={state.accountHolderName}
                            onChange={onChangeTextHandler}
                            type="text"
                          />
                        </FormItem>
                      </Col>
                      <Col md={5} className="mob-sec-bt">
                        <FormItem
                          name="bankAccountType"
                          label="Account Type"
                          colon={false}
                          rules={[
                            {
                              required: true,
                              message: "Please Select Account Type",
                            },
                          ]}
                        >
                          <UiDropDown
                            onChange={handleChangeSelect}
                            data={accountTypeListData}
                            // defaultValue={accountTypeListGet}
                          />
                        </FormItem>
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Row>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="accunt-num-main"
                      >
                        <Col md={6} className="accunt-num">
                          <div className="accout-box-form ">
                            <Form.Item
                              name="bankAccountNumber"
                              label="Account Number"
                              rules={[
                                {
                                  required: true,
                                  message: "Please Enter account Number",
                                },
                              ]}
                              hasFeedback
                            >
                              <TextInput
                                disabled={change}
                                onCopy={(e) => preventCopyPaste(e)}
                                onPaste={(e) => preventCopyPaste(e)}
                                onCut={(e) => preventCopyPaste(e)}
                                maxLength={255}
                                name="bankAccountNumber"
                                type="number"
                                value={state.bankAccountNumber}
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col md={6} className="accunt-num mob-sec-an">
                          <Form.Item
                            name="confirmaccuntNumber"
                            label="Re-enter Account Number"
                            dependencies={["bankAccountNumber"]}
                            hasFeedback
                            rules={[
                              {
                                required: true,
                                message: "Please confirm your account Number",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    getFieldValue("bankAccountNumber") === value
                                  ) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error("Account Number do not match!")
                                  );
                                },
                              }),
                            ]}
                          >
                            <Input.Password
                              disabled={change}
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trim();
                                }
                              }}
                              onCopy={(e) => preventCopyPaste(e)}
                              onPaste={(e) => preventCopyPaste(e)}
                              onCut={(e) => preventCopyPaste(e)}
                              maxLength={255}
                            />
                          </Form.Item>
                          <br></br>
                          <br></br>
                        </Col>
                      </Col>
                    </Row>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-field-right kjawgdyuf"
                    >
                      <Col md={6} className="mr-2">
                        <FormItem
                          label="Bank Name"
                          name="bankName"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Bank Name",
                            },
                          ]}
                          colon={false}
                        >
                          <AsyncSelect
                            placeholder={"Type 3 letters"}
                            value={bankInputValue}
                            loadOptions={loadBanks}
                            onChange={bankDropChange}
                          />
                        </FormItem>
                      </Col>
                      <Col md={5} className="turnover">
                        <FormItem
                          label="Branch"
                          name="bankBranchName"
                          rules={[
                            {
                              required: false,
                              message: "Please Enter Branch Name",
                            },
                          ]}
                          colon={false}
                          className="branch-drop"
                        >
                          {/* <AsyncSelect
                            isClearable={true}
                            placeholder={"Type 3 letters"}
                            value={branchInputValue}
                            loadOptions={loadBranch}
                            onChange={branchDropChange}
                          /> */}
                          <TextInput
                            onInput={(e) => {
                              if (e.target.value.trim() == "") {
                                e.target.value = e.target.value.trim();
                              }

                              if (e.target.value.trim() !== "") {
                                e.target.value = e.target.value.trimStart();
                              }
                            }}
                            maxLength={255}
                            type="text"
                          />
                        </FormItem>
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-field-right"
                    >
                      <Col md={6} className="Mobile-sec">
                        <FormItem
                          name="bankIFSCCode"
                          label="IFSC Code"
                          colon={false}
                          rules={[
                            {
                              required: true,
                              message: "Please Enter IFSC Code",
                            },
                            {
                              pattern: new RegExp(
                                "^[A-Za-z]{4}0[A-Z0-9a-z]{6}$"
                              ),
                              message: "Invalid IFSC CODE",
                            },
                          ]}
                        >
                          <TextInput
                            maxLength={255}
                            onInput={(e) => {
                              if (e.target.value.trim() == "") {
                                e.target.value = e.target.value.trim();
                              }

                              if (e.target.value.trim() !== "") {
                                e.target.value = e.target.value.trimStart();
                              }
                            }}
                            name="bankIFSCCode"
                            onChange={onChangeTextHandler}
                            value={state.bankIFSCCode}
                            type="text"
                          />
                        </FormItem>
                      </Col>
                      <Col md={6} className="Mobile-sec mob-sec-mc">
                        <FormItem
                          name="bankMICRCode"
                          label="MICR Code"
                          colon={false}
                          rules={[
                            {
                              required: false,
                              message: "Please Enter Firm Company Name",
                            },
                          ]}
                        >
                          <TextInput
                            name="bankMICRCode"
                            onInput={(e) => {
                              if (e.target.value.trim() == "") {
                                e.target.value = e.target.value.trim();
                              }

                              if (e.target.value.trim() !== "") {
                                e.target.value = e.target.value.trimStart();
                              }
                            }}
                            value={state.bankMICRCode}
                            onChange={onChangeTextHandler}
                            type="text"
                            maxLength={255}
                          />
                        </FormItem>
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12} xs={12} md={12} sm={12} className="last-sec">
                      <Col md={12} className="">
                        <FormItem
                          name="bankAddress"
                          label="Bank Address"
                          colon={false}
                          rules={[
                            {
                              required: false,
                              message: "Please Enter Bank Address ",
                            },
                          ]}
                        >
                          <TextInput
                            name="bankAddress"
                            value={state.bankAddress}
                            onInput={(e) => {
                              if (e.target.value.trim() == "") {
                                e.target.value = e.target.value.trim();
                              }

                              if (e.target.value.trim() !== "") {
                                e.target.value = e.target.value.trimStart();
                              }
                            }}
                            onChange={onChangeTextHandler}
                            type="text"
                            maxLength={255}
                          />
                        </FormItem>
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="last-sec-btn"
                    >
                      <Col md={12} className="checked-sec">
                        <FormItem
                          colon={false}
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Firm Company Name",
                            },
                          ]}
                        >
                          <Checkbox
                            value={partnerFirmMSMEFlagCheck}
                            checked={partnerFirmMSMEFlagCheck}
                            name="bankVerificationConsentFlag"
                            onChange={() =>
                              setPartnerFirmMSMEFlagCheck(
                                !partnerFirmMSMEFlagCheck
                              )
                            }
                          >
                            <p className="text-left">
                              By clicking on the checkbox, you provide express
                              consent and authorization, voluntarily,to Avanse
                              Financial Services Limited to
                              <br />
                              (i) Retrieve your Bank information through a third
                              party services provider Karza.
                              <br />
                              (ii) Use this information for identification,
                              verification and due-diligence purposes.
                            </p>
                          </Checkbox>
                        </FormItem>
                      </Col>
                      {/* <Col md={7} className="checked-sec">
                      {showText || imgIconShow ? (
                        <img
                          className="verifi-ic-btn"
                          src={VerificationIc}
                          alt=""
                        />
                      ) : null}
                    </Col> */}
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
            <div className="btnsection d-flex justify-content-end">
              {saveLoading ? (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              ) : (
                <Col md={4} className="mr-2">
                  {change ? (
                    <img
                      className="verifi-ic-btn"
                      src={VerificationIc}
                      alt=""
                    />
                  ) : null}
                </Col>
              )}
              {change ? (
                <UiButton title="change/Edit" onClick={handleEdit} />
              ) : null}
              {!change ? (
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="Verify Account"
                />
              ) : null}
            </div>
            <hr></hr>
          </div>
        </Form>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    data: state.firmDetailMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (accessToken, partnerFirmId) =>
      dispatch(getFirmAccountNumberDetail(accessToken, partnerFirmId)),
    searchBankDetails: (data) => dispatch(searchBankDetails(data)),
    searchBranchDetails: (data) => dispatch(searchBranchDetails(data)),
    saveAccountNoDetails: (data) => dispatch(saveAccountNoDetails(data)),
    clearLogoutData: (data) => dispatch(clearLogoutData(data)),
    getfirmMaster: (accessToken) => dispatch(firmDetailMaster(accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModifyBankDetails);
